<div class="p-4">
  <mat-card class="p-4">
    @if (selectedQuoteLoading()) {
      <div class="flex justify-center p-4">
        <mat-spinner></mat-spinner>
      </div>
    } @else if (selectedQuoteError()) {
      <div class="flex justify-center p-4">
        <p class="text-red-500">{{ errorText }}</p>
      </div>
    } @else {
      <div class="p-4 flex justify-between">
        <div class="flex flex-col gap-2">
          <h2 class="text-xl font-medium pb-4">View Quote # {{ selectedQuote()?.quoteId }}</h2>

          <div>
            <p>
              <span class="font-medium">Created By</span>:
              {{ selectedQuote()?.createdBy?.firstName }}
              {{ selectedQuote()?.createdBy?.lastName }}
            </p>
            <p>
              <span class="font-medium">Created On</span>:
              {{ selectedQuote()?.dateCreated | date: CONFIG.date.createdDateFormat }}
            </p>

            <div
              *ngIf="selectedQuote()?.estShipDate"
              class="border-dotted border-b border-gray-200 mt-6"
            >
              <p class="mb-2 font-medium">Est. Ship Date:</p>
              <p>{{ selectedQuote()?.estShipDate }}</p>
            </div>
          </div>

          <div class="mt-4">
            <h3 class="text-lg font-medium mb-2">Quote Details</h3>
            <div class="grid grid-cols-2 gap-4">
              <div class="flex items-center">
                <mat-checkbox
                  [checked]="selectedQuote()?.certsRequired || false"
                  disabled
                  class="mr-2"
                  id="certsRequired"
                >
                  Certs Required
                </mat-checkbox>
              </div>

              <div class="flex items-center">
                <mat-checkbox
                  [checked]="selectedQuote()?.cfm || false"
                  disabled
                  class="mr-2"
                  id="cfm"
                >
                  CFM
                </mat-checkbox>
              </div>

              <div class="flex items-center">
                <mat-checkbox
                  [checked]="selectedQuote()?.testReports || false"
                  disabled
                  class="mr-2"
                  id="testReports"
                >
                  Test Reports
                </mat-checkbox>
              </div>

              <div class="flex items-center">
                <mat-checkbox
                  [checked]="selectedQuote()?.ciwToSupplyWire || false"
                  disabled
                  class="mr-2"
                  id="ciwToSupplyWire"
                >
                  CIW To supply wire
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-4 min-w-80">
          <div>
            <h4 class="font-medium mb-1">Assignee:</h4>
            <p class="pl-4">{{ selectedQuote()?.assignee.firstName }}</p>
          </div>

          <div>
            <h4 class="font-medium mb-1">Status:</h4>
            <p class="pl-4">{{ selectedQuote()?.status?.value }}</p>
          </div>

          <div>
            <h4 class="font-medium mb-1">Shipping Method:</h4>
            <p class="pl-4">{{ selectedQuote()?.shippingMethod?.value }}</p>
          </div>

          <div>
            <h4 class="font-medium mb-1">Feet Per Reel:</h4>
            <p class="pl-4">{{ selectedQuote()?.feetPerReel }}</p>
          </div>

          <div>
            <h4 class="font-medium mb-1">Client:</h4>
            <div class="space-y-1">
              <p class="pl-4">#{{ selectedQuote()?.client?.code }}</p>
              <p class="pl-4">{{ selectedQuote()?.client?.company }}</p>
              <p class="pl-4">
                {{ selectedQuote()?.client?.firstName }} {{ selectedQuote()?.client?.lastName }}
              </p>
              <p class="pl-4">{{ selectedQuote()?.client?.email }}</p>
              <p class="pl-4">{{ selectedQuote()?.client?.phone }}</p>
            </div>
          </div>

          <div>
            <h4 class="font-medium mb-1">Attachments:</h4>
            @if (selectedQuote()?.attachments?.length) {
              <div class="pl-4">
                @for (attachment of selectedQuote().attachments; track attachment) {
                  <div class="flex items-center gap-2">
                    <span>{{ attachment.fileName }}</span>
                    <button mat-flat-button color="primary" (click)="viewAttachment(attachment)">
                      VIEW
                    </button>
                  </div>
                }
              </div>
            } @else {
              <p class="pl-4">No attachments</p>
            }
          </div>
        </div>
        <div class="w-64">
          <div class="bg-white rounded shadow-md p-4">
            <h3 class="text-gray-600 font-normal mb-4 pb-2">Options</h3>

            <a
              class="py-3 flex justify-between items-center cursor-pointer hover:text-blue-500"
              [routerLink]="['/quotes', route.snapshot.paramMap.get('id'), 'edit']"
            >
              <span>Edit Details</span>
              <mat-icon>edit</mat-icon>
            </a>

            <button
              class="w-full font-normal py-3 flex justify-between items-center cursor-pointer hover:text-blue-500"
              (click)="deleteQuote()"
            >
              <span>Delete</span>
              <mat-icon>delete</mat-icon>
            </button>

            <button
              class="w-full font-normal py-3 flex justify-between items-center cursor-pointer hover:text-blue-500"
              (click)="duplicateQuote()"
            >
              <span>Duplicate</span>
              <mat-icon>copy_all</mat-icon>
            </button>

            <button
              class="w-full font-normal py-3 flex justify-between items-center cursor-pointer hover:text-blue-500"
              (click)="changeArchiveStatus()"
            >
              <span>{{ selectedQuote()?.archived ? 'Unarchive' : 'Archive' }}</span>
              <mat-icon>archive</mat-icon>
            </button>

            <button
              class="w-full font-normal py-3 flex justify-between items-center cursor-pointer hover:text-blue-500"
              (click)="exportQuote()"
            >
              <span>Export</span>
              <mat-icon>print</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="m-4 pb-2 border-dotted border-b border-gray-200">
        <p class="mb-2 font-medium">Quote Description:</p>
        <p>{{ selectedQuote()?.description }}</p>
      </div>

      <div class="p-4">
        <div class="grid grid-cols-2 gap-6 mb-2">
          <div class="bg-blue-500 text-white p-3 mb-2 h-12">
            <h2 class="text-lg font-medium">Quantity Details</h2>
          </div>

          <div class="bg-blue-500 p-1 mb-2">
            <div class="quote-type-radio-group flex items-center text-white px-3 py-2">
              {{ selectedQuote()?.caNumber ? 'Quote by CA Number' : 'Custom Quote' }}
            </div>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-6 mb-8 h-full">
          <div class="p-4 pt-0 border border-gray-200 h-full">
            <div class="p-6 flex items-center justify-center">
              <h4 class="font-medium mr-2">Quantity:</h4>
              <p>{{ selectedQuote()?.quantity }}</p>
            </div>
            <hr />
            <div class="p-6 flex items-center justify-center">
              <div class="flex items-center">
                <input
                  type="checkbox"
                  [checked]="selectedQuote()?.hasPieces || false"
                  disabled
                  class="mr-2"
                  id="breakQuoteIntoEach"
                />
                <label for="breakQuoteIntoEach">Break quote into each</label>
              </div>
            </div>
            <hr />
            @if (selectedQuote()?.hasPieces) {
              <div class="quantity-breaks">
                @for (break of selectedQuote()?.quantityBreaks; track $index) {
                  <div class="p-6">
                    <div class="flex items-center justify-around">
                      <h5 class="font-medium mr-2">Quantity Break {{ $index + 1 }}:</h5>
                      <p>{{ break.quantity }}ft</p>
                      <p>{{ break.pieces }} each</p>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <div class="quantity-breaks">
                @for (break of selectedQuote()?.quantityBreaks; track $index) {
                  <div class="p-6">
                    <div class="flex items-center justify-center">
                      <h5 class="font-medium mr-2">Quantity Break {{ $index + 1 }}:</h5>
                      <p>{{ break.quantity }}ft</p>
                    </div>
                  </div>
                }
              </div>
            }
          </div>

          <div class="p-4 pt-0 border border-gray-200 h-full flex flex-col justify-between">
            <div class="p-6 flex items-center justify-center">
              <p>
                {{
                  selectedQuote()?.caCustomDescription
                    ? selectedQuote()?.caCustomDescription
                    : selectedQuote()?.caNumber?.number
                }}
              </p>
            </div>
          </div>
        </div>
      </div>

      @if (constructionSheet()?.length > 0 && !selectedQuote()?.caCustomDescription) {
        <div class="grid grid-cols-1 gap-6 mb-8 p-4">
          <ciwc-construction-text
            [constructionSheet]="[constructionSheet()]"
            [isConstructionSheet]="true"
            [description]="constructionText()"
          ></ciwc-construction-text>
        </div>

        @if (processedConstructionSteps().length) {
          <mat-accordion class="p-4">
            <mat-expansion-panel #panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{
                    panel.expanded ? 'Hide All Construction Steps' : 'View All Construction Steps'
                  }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ciwc-construction-text
                [constructionSheet]="processedConstructionSteps()"
                [description]="remainingDescriptions()"
              ></ciwc-construction-text>
            </mat-expansion-panel>
          </mat-accordion>
        }
      }

      <div class="p-4">
        <div class="mt-4">
          <h2 class="text-lg font-medium pb-2">Quote Totals:</h2>
          @if (selectedQuote()?.quantityBreaks?.length) {
            @for (break of selectedQuote()?.quantityBreaks; track $index) {
              <ciwc-quote-total-tabs [tabs]="getQuoteTotalTabsForBreak($index)">
              </ciwc-quote-total-tabs>
            }
          } @else {
            <ciwc-quote-total-tabs [tabs]="getQuoteTotalTabsForBreak(0)"> </ciwc-quote-total-tabs>
          }
        </div>
      </div>

      <div class="p-4">
        <div class="acordeon-container p-4 pt-0 border border-gray-200 h-full">
          <div class="flex justify-between items-center py-4">
            <h2 class="text-lg font-medium pl-2">Quote Details:</h2>
          </div>
          @for (accordion of quoteDetailAccordions(); let i = $index; track i) {
            <ciwc-quote-detail-accordion
              [title]="accordion.title"
              [key]="accordion.key"
              [color]="accordion.color"
              [data]="accordion.data"
              [quantityBreaks]="selectedQuote()?.quantityBreaks || []"
              [readOnly]="true"
            >
            </ciwc-quote-detail-accordion>
          }
        </div>
      </div>

      <div class="p-4 grid grid-cols-2 gap-6">
        <div>
          <div class="bg-blue-500 text-white p-3 mb-2 h-12">
            <h2 class="text-lg font-medium">Note History</h2>
          </div>

          @if (selectedQuote()?.notes?.length) {
            <div class="mt-4 p-4">
              @for (note of savedNote() || selectedQuote().notes; let i = $index; track i) {
                <div class="mb-4 border-b-2 border-gray-200">
                  <p class="text-lg font-medium">{{ note.note }}</p>
                  <p class="text-right text-gray-600">
                    - {{ note.createdBy.firstName }} {{ note.createdBy.lastName }},
                    {{ note.dateCreated | date: CONFIG.date.createdDateFormat }}
                  </p>
                </div>
              }
            </div>
          }

          <form [formGroup]="notesForm" (ngSubmit)="saveNote()">
            <div class="grid grid-cols-3 gap-6 items-center">
              <mat-form-field class="w-full">
                <mat-label>Note</mat-label>
                <input matInput formControlName="notes" />
              </mat-form-field>
              <div></div>
              <button mat-flat-button color="primary" type="button" (click)="saveNote()">
                SAVE NOTE
              </button>
            </div>
          </form>
        </div>
        <div>
          <div class="bg-blue-500 text-white p-3 mb-2 h-12">
            <h2 class="text-lg font-medium">Quote Change History</h2>
          </div>

          @if (selectedQuote()?.historyLogs?.length) {
            <div class="mt-4 p-4">
              @for (log of selectedQuote().historyLogs; let i = $index; track i) {
                <div class="mb-4 border-b-2">
                  <p class="">
                    {{ log.createdBy.firstName }} {{ log.description }} on
                    {{ log.dateCreated | date: CONFIG.date.createdDateFormat }}
                  </p>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </mat-card>
</div>
